module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "tool"
    }
  }, [_vm._v("\n        Planning\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cols nav-planning"
  }, [_c('router-link', {
    staticClass: "btn prev btn-full",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "to": {
        name: 'agenda'
      }
    }
  }, [_c('i', {
    staticClass: "icon-go"
  }), _vm._v("\n            Retour\n        ")])], 1), _vm._v(" "), _vm._l((_vm.events), function(event) {
    return _c('div', {
      staticClass: "list",
      attrs: {
        "id": "list-events"
      }
    }, [_c('div', {
      staticClass: "fi-item"
    }, [_c('a', {
      staticClass: "list-item wrap",
      attrs: {
        "href": ("#/agenda?date=" + (event.start))
      }
    }, [_c('strong', {
      staticClass: "title"
    }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "date",
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v("\n                        Du " + _vm._s(_vm._f("dateFormat")(event.start, 'DD/MM/YYYY HH:mm')) + " au " + _vm._s(_vm._f("dateFormat")(event.end, 'DD/MM/YYYY HH:mm')) + "\n                    ")]), _vm._v(" "), _vm._l((event.installs), function(install) {
      return _c('div', {
        staticClass: "list-installs",
        staticStyle: {
          "margin-bottom": "5px"
        }
      }, [_c('span', {
        staticClass: "install-nom",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(install.nom))]), _vm._v(" "), _c('span', {
        staticClass: "install-modele",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(install.modele) + " " + _vm._s(install.marque))]), _vm._v(" "), _c('span', {
        staticClass: "commentaire",
        staticStyle: {
          "text-transform": "lowercase",
          "font-weight": "revert"
        }
      }, [_vm._v("\n                            " + _vm._s(install.commentaire) + "\n                        ")])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), (event.body) ? _c('span', {
      staticClass: "commentaire"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v("Commentaire : ")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "commentaire",
      staticStyle: {
        "text-transform": "lowercase",
        "font-weight": "revert"
      }
    }, [_vm._v(_vm._s(event.body))])]) : _vm._e()], 2)])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a2c18f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planning/ListeEvents.vue
// module id = 1042
// module chunks = 0